import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {AzPageHeader} from '../../components/AzPageHeader'
import { HeaderListWrapper } from './HeaderComponent'
import { useIntl } from 'react-intl'

const HeaderPage = () => {
  const intl = useIntl()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='header'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'MENU_NAVIGATION.PAGE_HEADER_TITLE' })} />
              <HeaderListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/header-management/header' />} />
    </Routes>
  )
}

export default HeaderPage
